import type { CommunityDetail } from '@pba/react-network';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { usePermissions } from 'permissions';
import { type MenuProps, UserSecurityLineIcon } from 'ui';
import { routes, useAdminDashboardRedirectMutation } from 'features/admin-dashboard';

export const useActions = ({ community }: { community: CommunityDetail }) => {
  const { t } = useTranslation();
  const { isPending: isRedirectingToAdminDashboard, mutate: redirectToAdminDashboard } =
    useAdminDashboardRedirectMutation();

  const { canManageCommunityDetail, canViewAdminDashboardCommunities } = usePermissions();

  return useMemo(() => {
    const actions: MenuProps['items'] = [];

    if (canViewAdminDashboardCommunities({}) || canManageCommunityDetail({ community })) {
      actions.push({
        disabled: isRedirectingToAdminDashboard,
        icon: <UserSecurityLineIcon />,
        key: 'view-in-admin-console',
        label: t('View in Admin Console'),
        onClick() {
          redirectToAdminDashboard({ referrer: routes.community.detail(community.id) });
        },
      });
    }

    // TODO: Will be used in Task #87927 for Community header view in user

    return {
      actions,
    };
  }, [
    canManageCommunityDetail,
    canViewAdminDashboardCommunities,
    community,
    isRedirectingToAdminDashboard,
    redirectToAdminDashboard,
    t,
  ]);
};
